import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { MainLayout } from '@/components/layout/MainLayout'
import { useContent } from '../../hooks/useContent';
import InsightsHero from '@/components/sections/InsightsHero';
import PolicyAreasSection from '@/components/sections/PolicyAreasSection';
import { ActionPlanProvider } from 'hooks/ActionPlanContext';
import HeroSection from '@/components/sections/HeroSection';
import PolicyAreaList from '@/components/action-plan/PolicyAreaList';
import ActionPlanSection from '@/components/action-plan/ActionPlanSection';


export const ActionPlansPage: React.FC = () => {
  const { content } = useContent();
  const { locale } = useRouter();

  return (
    <>
      <NextSeo
        title={'Türkiye’s Action Plan | Investment Office Türkiye'}
        description={
          'Explore detailed action plans outlining Türkiye&#x27;s strategic initiatives for attracting foreign direct investment. Discover key objectives, timelines, and steps to support your investment decisions in Türkiye.'
        }
        twitter={{
          cardType: 'summary_large_image',
        }}
        openGraph={{
          title: 'Türkiye’s Action Plan | Investment Office Türkiye',
          description:
            'Explore detailed action plans outlining Türkiye&#x27;s strategic initiatives for attracting foreign direct investment. Discover key objectives, timelines, and steps to support your investment decisions in Türkiye.',
          images: [
            {
              url: `https://uploads-ssl.webflow.com/666f68e852029a839d204e3c/6673c8c43f29cec166d3ab6b_fdi-action-plans-cover.webp`,
              width: 1024,
              height: 1024,
              type: 'image/jpeg',
            },
          ],
        }}
        noindex={locale === 'tr'}
        nofollow={locale === 'tr'}
      />
      <MainLayout isAnimateMenu={true}>
        <>
          <InsightsHero
            data={content.actionPlanHero}
          />

          <ActionPlanProvider>
            <>
              <PolicyAreaList></PolicyAreaList>
              <ActionPlanSection></ActionPlanSection>
            </>
          </ActionPlanProvider>
          <HeroSection
            heroData={{
              "tagline": "",
              "heading": "",
              "description": ""
            }}
            stickySections={content.goals}
          />
          <PolicyAreasSection
            cards={content.policyAreasSection.cards}
            tagline={content.policyAreasSection.tagline}
            heading={content.policyAreasSection.heading}
          />


        </>
      </MainLayout>
    </>
  )
}
